import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";

interface PWNotificationProps {
  message: string | ReactNode;
  setIsNotification: React.Dispatch<React.SetStateAction<boolean>>;
  isDisplayCloseIcon?: boolean;
  className?: string;
}

const PWNotification: React.FC<PWNotificationProps> = ({ message, setIsNotification, isDisplayCloseIcon = true, className }) => {

  return (
    <div className={className}>
      <div>
        {isDisplayCloseIcon && <CloseIcon style={{ width: "16px", height: "16px" }} className="notification-close" onClick={() => setIsNotification(false)} />}
        {message}
      </div>
    </div>
  );
};

export default PWNotification;
